import PropTypes from 'prop-types';
import { buildInitialIntlAttribute } from 'shared/lib/intl';

export const propTypes = {
  id: PropTypes.number,
  slug: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export const propTypesIntl = {
  id: PropTypes.number,
  slug: PropTypes.string,
  title: PropTypes.shape(buildInitialIntlAttribute(PropTypes.string)),
  description: PropTypes.shape(buildInitialIntlAttribute(PropTypes.string)),
};

export const defaultProps = {
  id: null,
  slug: null,
  title: null,
  description: null
};

export default { defaultProps, propTypes };
